import React from "react";
import { Search } from "lucide-react";
import { Input } from "../../../components/ui/input";

interface RepositorySearchInputProps {
  value: string;
  onChange: (value: string) => void;
}

const RepositorySearchInput = ({ value, onChange }: RepositorySearchInputProps) => {
  return (
    <div className="relative w-full min-w-[220px] md:max-w-sm">
      <Search className="pointer-events-none absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="pl-8"
        placeholder="Search by repository, owner, description"
      />
    </div>
  );
};

export default RepositorySearchInput;
